import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import axios from "axios";
import posthog from "posthog-js";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: () => import("@/views/ErrorScreen")
  },
  {
    path: "/",
    name: "lander",
    component: () => import("@/views/Lander")
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/Search")
  },
  {
    path: "/chatbot-search",
    name: "chatbotSearch",
    redirect: () => {
      return { path: '/search' }
    }
  },
  {
    path: "/chatbot-search/used-cars",
    name: "chatbotSearch",
    redirect: () => {
      return { path: '/search' }
    }
  },
  {
    path: "/watchlist",
    name: "watchlist",
    component: () => import("@/views/Watchlist")
  },
  /*{
    path: "/inquiries",
    name: "inquiries",
    component: () => import("@/views/Inquiries")
  },*/
  {
    path: "/out/:advertiserAccountId",
    name: "out",
    component: () => import("@/views/Out"),
    props: route => ({
      advertiserAccountId: route.params.advertiserAccountId
    })
  },
  {
    path: "/listing/:productId",
    name: "listing",
    redirect: to => {
      return { path: "/", query: { pid: to.params.productId } };
    }
  },
  {
    path: "/privacy-policy",
    name: "privacyPolicy",
    component: () => import("@/views/PrivacyPolicy"),
    meta: { noindex: true }
  },
  {
    path: "/terms-of-use",
    name: "termsOfUse",
    component: () => import("@/views/TermsOfUse"),
    meta: { noindex: true }
  },
  {
    path: "/third-parties",
    name: "thirdParties",
    component: () => import("@/views/ThirdParties"),
    meta: { noindex: true }
  },
  {
    path: "/ccpa-opt-out",
    name: "ccpaOptOut",
    beforeEnter() {
      window.open("https://search.carscience.com/ccpa.php", "_blank");
      return false;
    },
    meta: { noindex: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  // Make sure "utm_campaign" param is always retained
  if (Object.prototype.hasOwnProperty.call(to.query, "utm_campaign")) {
    sessionStorage.setItem(
      "carscience-session-utm-campaign-id",
      to.query.utm_campaign
    );
  }
  if (
    sessionStorage.getItem("carscience-session-utm-campaign-id") !== null &&
    !Object.prototype.hasOwnProperty.call(to.query, "utm_campaign")
  ) {
    to.query.utm_campaign = sessionStorage.getItem(
      "carscience-session-utm-campaign-id"
    );
    next({ path: to.path, query: to.query });
    return;
  }

  axios.defaults.headers.common["Authorization"] =
    "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImtpZCI6Im5ldHdvcmstcHVibGlzaGVyLXRva2VuIn0.eyJpc3MiOiJodHRwczpcL1wvYXBpLmp1bXBmZWVkLmNvbSIsImlhdCI6MTcwNzkyNTQ5MiwiZXhwIjozMjg1ODQ4NjkyLCJzY29wZSI6WyJjcmVhdGUiLCJyZWFkIiwidXBkYXRlIiwiZGVsZXRlIiwibGlzdCIsImFsbCJdLCJpcCI6IjE5Mi4xNjguNjUuMSIsInB1Ymxpc2hlcl9hY2NvdW50Ijoie1wiaWRcIjpcIjEwMDAxXCIsXCJidXNpbmVzc19pZFwiOlwiMTVcIixcIm5hbWVcIjpcIkp1bXBmZWVkIFB1Ymxpc2hlclwiLFwicGF5b3V0X3ZhbHVlX3JldGFpbl9wZXJjZW50YWdlXCI6XCIxMDBcIixcInRpbWVfY3JlYXRlZFwiOlwiMjAyMy0wMS0wNiAxODozMDowMVwiLFwidGltZV91cGRhdGVkXCI6bnVsbCxcImRlbGV0ZWRcIjpcIjBcIixcInRpbWVfZGVsZXRlZFwiOm51bGwsXCJkb21haW5cIjpcImNhcnNjaWVuY2UuY29tXCIsXCJwdWJsaXNoZXJfYWNjb3VudF9kb21haW5faWRcIjpcIjdcIn0ifQ.btUtWpqcArLi0bmQt5FnW4GFZYjAkbQqr9ozjtpMG-0";

  let promiseChain = [];
  if (!store.state.publisher.jfpcScriptAttached) {
    promiseChain.push(store.dispatch("publisher/ATTACH_JFPC_SCRIPT"));
  }
  if (!store.getters["geolocation/isSet"]) {
    promiseChain.push(store.dispatch("geolocation/GET_REQUEST"));
  }
  if (!store.getters["vehicleMakeModels/isSet"]) {
    promiseChain.push(store.dispatch("vehicleMakeModels/GET_REQUEST"));
  }

  if (promiseChain.length > 0) {
    store.state.appLoading = true;
  }

  Promise.all(promiseChain).then(() => {
    if (
      typeof store.state.geolocation.country === "string" &&
      store.state.geolocation.country === "US" &&
      typeof store.state.geolocation.postalCode === "string" &&
      store.state.geolocation.postalCode.length === 5
    ) {
      if (!store.getters["search/locationSet"]) {
        store.commit(
          "search/SET_LOCATION",
          store.getters["geolocation/searchLocationObject"]
        );
      }
    }

    if (to.path === "/search") {
      if (Object.prototype.hasOwnProperty.call(to.query, "query")) {
        store.commit("search/SET_STATE_FROM_QUERY_PARAM", to.query.query);
      }
      store.commit("search/SET_LOADING");
    }

    next();
  });
});

router.afterEach(() => {
  store.state.appLoading = false;

  window.scrollTo({ top: 0, behavior: "smooth" });
  let page = document.getElementById("page_container");
  page.scrollIntoView({ behavior: "smooth", block: "start" });

  window.jfpe.track("PageView");
});

posthog.init("phc_jxe7Ay4cqhryJHg7PMiJMbiE5LfvpJFJmuIZ2wB3xSv", {
  api_host: "https://us.i.posthog.com",
  defaults: "2025-11-30",
  person_profiles: "always" // or 'always' to create profiles for anonymous users as well
});

export default router;
